import { render, staticRenderFns } from "./FloorplanCanvas.vue?vue&type=template&id=b5153b3a&scoped=true&"
import script from "./FloorplanCanvas.vue?vue&type=script&lang=js&"
export * from "./FloorplanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./FloorplanCanvas.vue?vue&type=style&index=0&id=b5153b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5153b3a",
  null
  
)

export default component.exports